import React from "react";
import { circle, spinnerContainer } from "./CircleSpinner.css.js";

const CircleSpinner: React.FC = () => (
    <div className={spinnerContainer}>
        <span className={circle} />
        <span className={circle} />
        <span className={circle} />
    </div>
);

export default CircleSpinner;
